const apiUrl = process.env.REACT_APP_API_URL;

export const GetAlumnesValidacioByProjectV2 = async (id_projecte: string, id_usuari: string, id_recuperacio?: number) => {
    try {
        let url = `${apiUrl}:8061/projectes/${id_projecte}/alumnes/${id_usuari}/validacio/v2`;
        if (id_recuperacio !== undefined) {
            url += `?id_recuperacio=${id_recuperacio}`;
        }
        const response = await fetch(url, {
            cache: 'no-store'
        });
        if (!response.ok) return [];
        const data = await response.json();
        return data.map((item: any) => ({
            ...item,
            rubrica: typeof item.rubrica === 'string' ? JSON.parse(item.rubrica) : (item.rubrica || [])
        }));
    } catch (error) {
        console.log('Error:', error);
        return [];
    }
};

export const PostValidacioRubrica = async (
    id_projecte: string,
    id_alumne: string,
    id_rubrica: number,
    avaluacio: number,
    observacions: string = "",
    id_recuperacio?: number
) => {
    try {
        const response = await fetch(
            `${apiUrl}:8061/projectes/${id_projecte}/alumnes/${id_alumne}/validacio/rubrica/${id_rubrica}`,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ avaluacio, observacions, id_recuperacio })
            }
        );
        if (!response.ok) alert(await response.text());
    } catch (error) {
        console.log('Error:', error);
    }
};
